import { render, staticRenderFns } from "./ModifierOffreVoyage.vue?vue&type=template&id=47f0c247&scoped=true"
import script from "./ModifierOffreVoyage.vue?vue&type=script&lang=js"
export * from "./ModifierOffreVoyage.vue?vue&type=script&lang=js"
import style0 from "./ModifierOffreVoyage.vue?vue&type=style&index=0&id=47f0c247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0c247",
  null
  
)

export default component.exports